import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never retry 401s
        if (error && typeof error === 'object' && 'status' in error && (error as any).status === 401) {
          return false;
        }
        // Also check for axios-style response.status
        if (error && typeof error === 'object' && 'response' in error && (error as any).response?.status === 401) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});
